import { Typography } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import Logo from "../../../assets/images/logo_medium.png";
import { StyledLoading } from "../../styled/loading";

export default function LoadingComponent({ finishLoadingText }) {
  return (
    <StyledLoading.Root>
      <StyledLoading.Logo src={Logo} alt="" />
      {finishLoadingText ? <Typography sx={{ textAlign: 'center', mt: 2 }} variant="body1">{finishLoadingText}</Typography> : <CircularProgress />}
    </StyledLoading.Root>
  );
}
